import React from 'react'

const ImproveCard = () => {
    return (
        <div className="card-container bg-layout border border-layout-border rounded-lg p-3 gap-4">
            <div className="inner-section flex flex-col gap-4">
                <div className="top-section text-error font-semibold text-sm"><h2>
                Needs Attention</h2></div>

                <div className="middle-section">
                    <div className="inner-middle flex items-center gap-2">    
                                        <h1 className='text-color-gray-light text-lg font-semibold'>252 Tests</h1> 
                    </div>
                </div>

                <div className="bottom-section">
                    <span className='text-filter-color font-normal text-xs  underline'>Page 2-8</span>
                </div>
            </div>
        </div>
    )
}

export default ImproveCard